import { Box, Input, InputGroup, FormLabel, Text, Textarea, Image, Button } from '@chakra-ui/react'
import React from 'react'

export const Form = () => {
  return (
    <div>
        <Box  py='3rem' px='2rem' bg='#F5F8FF'>
            <Text fontSize={['24px','2rem']} color='#1F1F29' textAlign='center' fontWeight='500' fontFamily='Duplicate Sans'>Got more Questions?</Text>
            <Text mt='1rem' mb='2rem' color='#1F1F29' textAlign='center' noOfLines={2} lineHeight={['32px','']} fontSize={['10px',".75rem",".75rem",'1rem']} >
            Tell us what you need and we’ll find the best solution for you.
            </Text>
            <Box  mb='1rem' w={['full','75%']} m='auto' >
                <form>
                    <InputGroup flexDirection='column'>
                        <FormLabel fontSize={['10px','14px']} color='#1F1F29'>First Name</FormLabel>
                        <Input borderRight='12px' bg='#fff' fontSize={['12.5px',".75rem",".75rem",'16px']} border='1px solid #E8E8E8' placeholder='Enter your full name' color='#a0a4a8' />
                    </InputGroup>
                    <InputGroup mt='1rem' flexDirection='column'>
                        <FormLabel fontSize={['10px','14px']} color='#1F1F29'>Email address</FormLabel>
                        <Input borderRight='12px' bg='#fff' fontSize={['12.5px',".75rem",".75rem",'16px']} border='1px solid #E8E8E8' placeholder='Enter your email address' color='#a0a4a8' />
                    </InputGroup>
                    <InputGroup mt='1rem' mb='1rem' flexDirection='column'>
                        <FormLabel fontSize={['10px','14px']} color='#1F1F29'>What are you looking for?</FormLabel>
                        <Textarea borderRight='12px' bg='#fff' minW='295px' minH='145px' fontSize={['12.5px',".75rem",".75rem",'16px']} border='1px solid #E8E8E8' placeholder='Message' color='#a0a4a8' />
                    </InputGroup>
                    <Button
            href="#services"
            _hover={{ textDecoration: 'none' }}
            textAlign="center"
            fontFamily='Work Sans'
            display='flex'
            alignItmes='center'
            fontSize={['.7rem', '1rem', '.7rem', '.9rem']}
            color="#fff"
            bg="#166BFD"
            p={['.75rem 1.5rem', ' 16px, 24px, 16px, 24px', ' 16px, 24px, 16px, 24px','16px, 24px, 16px, 24px']}
            w={['130px','160px','160px','160px']} h={['44px','50px','50px','54px']}
            borderRadius="8px"
            fontWeight="500"
            _active={{ color: '#000' }}
          >
            Send message&nbsp;{' '}
            <Image
              src="/hero_arrow.png"
              _hover={{ marginLeft: '.2rem' }}
            boxSize='1rem'
              alt="socials"
            />
          </Button>
                </form>
            </Box>
        </Box>
        
    </div>
  )
}
